import { Button } from '@octano/global-ui';
import { Fragment, useState } from 'react';

import {
  AxiosResult,
  AxiosResultDefaultError,
} from '../../../../web/src/api/request';
import ImageCropAndUploadModal, {
  ImageCropAndUploadModalTexts,
} from './ImageCropAndUploadModal';

export interface ImageCropAndUploadProps {
  defaultPhoto?: string | null;
  texts: ImageCropAndUploadTexts;
  onError: (error: string) => void;
  submitFuction: (
    photo: File | undefined,
  ) => Promise<AxiosResult<unknown, AxiosResultDefaultError>>;
}

export interface ImageCropAndUploadTexts extends ImageCropAndUploadModalTexts {
  upload: string;
  reupload: string;
}

const ImageCropAndUpload = (props: ImageCropAndUploadProps) => {
  const {
    texts,
    submitFuction,
    onError,
    defaultPhoto: defaultPhotoProp,
  } = props;

  const [defaultPhoto, setDefaultPhoto] = useState(defaultPhotoProp);

  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <div className="image-square-container">
        <div className="image-square">
          <img
            src={defaultPhoto || '/images/no-photos.png'}
            className="img img-responsive full-width"
            alt="student"
          />
        </div>
        <Button
          className="position-relative"
          text={defaultPhoto ? texts.reupload : texts.upload}
          size="sm"
          color="primary"
          fullwidth
          onClick={() => {
            setOpen(true);
          }}
        />
      </div>
      <ImageCropAndUploadModal
        open={open}
        currentPhoto={defaultPhoto}
        texts={texts}
        submitFuction={submitFuction}
        onClose={() => setOpen(false)}
        onError={onError}
        onSuccess={(src) => {
          setOpen(false);
          setDefaultPhoto(src);
        }}
      />
    </Fragment>
  );
};

export default ImageCropAndUpload;
